var SVG_NS = "http://www.w3.org/2000/svg";
var NONE = "none";

export { SVG_NS, NONE };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/svg/constants.js
// module id = 100
// module chunks = 0